


export let GETHOTELS_REQUEST="GETHOTELS_REQUEST";

export let GETHOTELS_SUCCESS="GETHOTELS_SUCCESS";

export let GETHOTELS_FAILURE="GETHOTELS_FAILURE";


// for payment //

export let TOTALPRICE="TOTALPRICE "
export let TOTAL_DAYS="TOTAL_DAYS";

export let SEARCH_PLACE="SEARCH_PLACE";
export let TOTAL_ADULTS="TOTAL_ADULTS";
export let TOTAL_ROOMS="TOTAL_ROOMS";

//for filter (SideBar)

export let FILTER_BY_SERVICE="FILTER_BY_SERVICE";
export let FILTER_BY_STAR="FILTER_BY_STAR";
export let FILTER_BY_PRICE="FILTER_BY_PRICE";
